import {useEffect} from "react"
import LogRocket from "logrocket"
import * as Sentry from "@sentry/react"

interface LogRocketOptions {
  sampleRate?: number
  currentUserEmail?: string
}

const useLogRocket = (options?: LogRocketOptions) => {
  const isProd = import.meta.env.VITE_RAILS_ENV === "production"
  const isBrowser = typeof window !== "undefined"
  const key = import.meta.env.VITE_LOGROCKET_KEY

  const isWithinSampleRate = options?.sampleRate ? Math.random() < options.sampleRate : true
  const skipInitialization = options?.currentUserEmail?.endsWith("@poweredbypark.com")

  useEffect(() => {
    if (!(key && isBrowser && isProd && isWithinSampleRate) || skipInitialization) return

    LogRocket.init(key)

    LogRocket.getSessionURL((sessionURL) => {
      Sentry.setExtra("sessionURL", sessionURL)
    })
  }, [isWithinSampleRate, skipInitialization])

  const identifyUser = (user: { id?: string; email: string }, campName?: string) => {
    Sentry.setUser({
      id: user?.id || user?.email,
    })

    LogRocket.identify(user.id || user.email, {
      email: user.email,
      campName: campName || "unknown camp",
    })
  }

  return identifyUser
}

export default useLogRocket
